import React, { useState, useEffect, useMemo } from 'react'

import { Link } from 'react-router-dom'
import { Row, Col, Spin } from 'antd'

import { Main, CardToolbox } from '../styled'
import { PageHeader } from '../../components/page-headers/page-headers'
import { Button } from '../../components/buttons/buttons'

import { AutoComplete } from '../../components/autoComplete/autoComplete'

import { useTranslation } from 'react-i18next'

import { GetCarRenters } from './dataQueries'
import {
  setAllCarRenters,
  setTableFiler
} from '../../redux/car_renters/actionCreator'

import List from './overview/list'
import { useDispatch, useSelector } from 'react-redux'
import NewRecordModal from './newRecordModal'
import { filtrujZoznam } from '../../utils/hladanie'
import { PanelFiltrov } from '../../components/filtre/panelFiltrov'

const graphqlVariables = {
  tokenGet: process.env.REACT_APP_TOKEN_GET,
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION
}

const CarRentersGrid = () => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()

  const [gridState, setGridState] = useState({
    addNewRecord: false
  })
  const showNewRecordModal = () => {
    setGridState({
      ...gridState,
      addNewRecord: true
    })
  }
  const onCancel = () => {
    setGridState({
      ...gridState,
      addNewRecord: false
    })
  }

  const handleCancel = () => {
    onCancel()
  }

  const tableData = useSelector(state => state?.carRenters?.allCarRenters)

  const [loadData, setLoadData] = useState(false)
  const [loadingList, setLoadingList] = useState(true)
  const [hladanie, setHladanie] = useState('')
  const PRAZDNE_FILTRE = { maRezervacnyMail: undefined, platcaDph: undefined }
  const [filtre, setFiltre] = useState(PRAZDNE_FILTRE)

  useEffect(() => {
    setLoadData(true)
  }, [])

  // Pomocnik vracia undefined, kym nie su data. Bez tejto poistky padne
  // cela stranka na "Cannot read properties of undefined (reading '0')".
  const graphQlData = GetCarRenters(graphqlVariables, loadData) || []
  const najomcovia = graphQlData[0]?.data?.getCarRenters
  const nacitavaSa = graphQlData[0]?.loading

  // Zapis do uloziska patri do efektu, nie do vykreslovania. Predtym sa
  // dispatch volal priamo pocas renderu, co React hlasi ako chybu a pri
  // kazdom prekresleni to spustalo dalsie prekreslenie.
  useEffect(() => {
    if (!najomcovia) return
    dispatch(setAllCarRenters(najomcovia))
    setLoadingList(Boolean(nacitavaSa))
    setLoadData(false)
  }, [najomcovia, nacitavaSa, dispatch])

  // Hlada sa vo vsetkom, co je o najomcovi v zozname, nie len v nazve firmy.
  const handleSearch = searchText => {
    setHladanie(typeof searchText === 'string' ? searchText : '')
  }

  const definicieFiltrov = useMemo(
    () => [
      {
        kluc: 'maRezervacnyMail',
        popis: 'E-mail na rezervácie',
        typ: 'vyber',
        sirka: 6,
        moznosti: [
          { hodnota: 'ano', popis: 'vyplnený' },
          { hodnota: 'nie', popis: 'chýba' }
        ]
      },
      {
        kluc: 'platcaDph',
        popis: 'Platiteľ DPH',
        typ: 'vyber',
        sirka: 6,
        moznosti: [
          { hodnota: 'ano', popis: 'áno' },
          { hodnota: 'nie', popis: 'nie' }
        ]
      }
    ],
    [tableData]
  )

  const zobrazeni = useMemo(() => {
    const maHodnotu = h => String(h ?? '').trim() !== ''
    let data = filtrujZoznam(tableData, hladanie, item => [
      item?.company,
      item?.firstname,
      item?.lastname,
      item?.email,
      item?.phone,
      item?.street,
      item?.city,
      item?.zip,
      item?.ic,
      item?.dic,
      item?.ic_dph
    ])
    if (filtre.maRezervacnyMail) {
      const chcem = filtre.maRezervacnyMail === 'ano'
      data = data.filter(p => maHodnotu(p?.reservation_emails) === chcem)
    }
    if (filtre.platcaDph) {
      const chcem = filtre.platcaDph === 'ano'
      data = data.filter(p => maHodnotu(p?.ic_dph) === chcem)
    }
    return data
  }, [tableData, hladanie, filtre])

  useEffect(() => {
    dispatch(setTableFiler(zobrazeni))
  }, [zobrazeni, dispatch])

  return (
    <>
      <CardToolbox>
        <PageHeader
          ghost
          title={t('carRenters.list')}
          subTitle={
            <>
              <span className='title-counter'>{t('carOwners.filter')} </span>
              <AutoComplete
                onSearch={handleSearch}
                // dataSource={notData}
                placeholder={t('carOwners.startWritting')}
                width='100%'
                patterns
              />
            </>
          }
          buttons={[
            <Button
              onClick={showNewRecordModal}
              className='btn-add_new'
              size='default'
              type='primary'
              key='1'
            >
              {/* <Link to="/admin/users/add-user/info">+ Add New Car</Link> */}
              <Link to='#'>{t('common.addRecord')}</Link>
            </Button>
          ]}
        />
      </CardToolbox>
      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <PanelFiltrov
              filtre={definicieFiltrov}
              hodnoty={filtre}
              onZmena={(kluc, hodnota) =>
                setFiltre(predosle => ({ ...predosle, [kluc]: hodnota }))
              }
              onVycistit={() => setFiltre(PRAZDNE_FILTRE)}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col md={24}>
            {loadingList && (
              <div className='spin'>
                <Spin />
              </div>
            )}
            {!loadingList && (
              <List inputData={zobrazeni} graphqlVariables={graphqlVariables} />
            )}
          </Col>
        </Row>
      </Main>
      <NewRecordModal
        t={t}
        gridState={gridState}
        handleCancel={handleCancel}
        onCancel={onCancel}
        tableData={tableData}
      />
    </>
  )
}

export default CarRentersGrid
